"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavMenuItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Button = require("../Buttons/Button");
var _Icon = require("../Icon/Icon");
var _Link = require("../Link/Link");
var _Overlay = require("../Overlay/Overlay");
var _Tooltip = require("../Tooltip/Tooltip");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useTypeToFocus2 = require("../utils/useTypeToFocus");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenuItem.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-nav-menu-item';
var NavMenuItem = exports.NavMenuItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _a, _b;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _c = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(NavMenuItem, props)) : props,
    ariaCurrent = _c.ariaCurrent,
    disabled = _c.disabled,
    label = _c.label,
    children = _c.children,
    hideMainMenu = _c.hideMainMenu,
    hoverToOpen = _c.hoverToOpen,
    linkRef = _c.linkRef,
    href = _c.href,
    className = _c.className,
    overlayProps = _c.overlayProps,
    iconProps = _c.iconProps,
    linkProps = _c.linkProps,
    buttonProps = _c.buttonProps,
    submenuListProps = _c.submenuListProps,
    isSubMenu = _c.isSubMenu,
    inNavMenuBar = _c.inNavMenuBar,
    size = _c.size,
    level = _c.level,
    onShow = _c.onShow,
    onHide = _c.onHide,
    onClick = _c.onClick,
    onKeyDown = _c.onKeyDown,
    inToolbarOverflow = _c.inToolbarOverflow,
    tooltipMessage = _c.tooltipMessage,
    tooltipProps = _c.tooltipProps,
    itemProps = __rest(_c, ["ariaCurrent", "disabled", "label", "children", "hideMainMenu", "hoverToOpen", "linkRef", "href", "className", "overlayProps", "iconProps", "linkProps", "buttonProps", "submenuListProps", "isSubMenu", "inNavMenuBar", "size", "level", "onShow", "onHide", "onClick", "onKeyDown", "inToolbarOverflow", "tooltipMessage", "tooltipProps"]);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var overlayRef = (0, _react.useRef)(null);
  var internalButtonRef = (0, _react.useRef)(null);
  var internalListRef = (0, _react.useRef)(null);
  var classnames = _bind.default.bind(_NavMenuItem.default);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(function () {
    if (children) {
      if (isOpen) {
        onShow === null || onShow === void 0 ? void 0 : onShow();
      } else if (isOpen === false) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }
    }
  }, [isOpen, children]);
  var handleClick = function handleClick() {
    if (children) {
      setIsOpen(!isOpen);
    } else {
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu();
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (hoverToOpen && children) {
      setIsOpen(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (hoverToOpen && children) {
      setIsOpen(false);
    }
  };
  var handleNodeKeyDown = function handleNodeKeyDown(event) {
    var _context;
    if ((0, _includes.default)(_context = ['enter', 'space', 'right']).call(_context, (0, _keycode.default)(event))) {
      event.preventDefault();
      handleClick();
    } else if (inNavMenuBar && (0, _keycode.default)(event) === 'left' && !isSubMenu) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  var handleLinkKeyDown = function handleLinkKeyDown(event) {
    var _context2;
    var _a, _b;
    if ((0, _includes.default)(_context2 = ['enter', 'space']).call(_context2, (0, _keycode.default)(event))) {
      (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
    } else if (inNavMenuBar && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'left' && !isSubMenu)) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  var handleDisabledKeyDown = function handleDisabledKeyDown(event) {
    var _context3;
    if ((0, _includes.default)(_context3 = ['enter', 'space']).call(_context3, (0, _keycode.default)(event))) {
      return;
    }
    if (inNavMenuBar && ((0, _keycode.default)(event) === 'right' || (0, _keycode.default)(event) === 'left' && !isSubMenu)) {
      event.preventDefault();
      hideMainMenu === null || hideMainMenu === void 0 ? void 0 : hideMainMenu((0, _keycode.default)(event));
    }
  };
  var handleSubMenuKeyDown = function handleSubMenuKeyDown(event) {
    var _a, _b;
    if (isOpen && (0, _keycode.default)(event) === 'left') {
      event.stopPropagation();
      setIsOpen(false);
      (_b = (_a = internalButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  };
  var _useTypeToFocus = (0, _useTypeToFocus2.useTypeToFocus)({
      focusCandidates: (0, _from.default)(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
      keyStrokeTimeout: 50,
      focusMatchingItem: _navMenuUtils.focusMatchingItem
    }),
    handleTypeToFocus = _useTypeToFocus.handleTypeToFocus;
  var icon = /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _assign.default)({
    ariaHidden: true,
    iconName: "arrow-2-e",
    size: "xs-plus",
    forceSize: "xs-plus",
    "data-level": level
  }, iconProps, {
    className: classnames(iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__icon--disabled"), disabled), "".concat(CSS_BLOCK, "__overflow-menu-icon"), inToolbarOverflow)),
    "data-nui-widgets": "menuitem-node"
  }));
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, itemProps, {
      ref: ref,
      role: "menuitem",
      "aria-disabled": true,
      tabIndex: 0,
      "data-nui-widgets": "menuitem-leaf",
      onKeyDown: handleDisabledKeyDown,
      className: classnames(className, "".concat(CSS_BLOCK, "--disabled"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__link--sub"), !!children), "".concat(CSS_BLOCK, "__link--md"), size === 'md'))
    }), label, children && icon);
  }
  var passChildProps = function passChildProps(child) {
    if (child.displayName === 'NavMenuItem') {
      var navMenuItemProps = {
        isSubMenu: true,
        hideMainMenu: hideMainMenu,
        inNavMenuBar: inNavMenuBar,
        hoverToOpen: hoverToOpen,
        size: size,
        inToolbarOverflow: inToolbarOverflow,
        level: (level || 0) + 1
      };
      return navMenuItemProps;
    }
    return {};
  };
  var buttonTarget = /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _assign.default)({
    type: "link"
  }, buttonProps, {
    role: "menuitem",
    "data-level": level,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-current": !!ariaCurrent || undefined,
    "data-nui-widgets": "menuitem-node",
    disabled: disabled,
    className: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, "".concat(CSS_BLOCK, "__link"), "".concat(CSS_BLOCK, "__link--sub"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__link--md"), size === 'md'), "".concat(CSS_BLOCK, "__overlay-link"), typeof hideMainMenu === 'function'), "".concat(CSS_BLOCK, "__link--open"), isOpen), "".concat(CSS_BLOCK, "__link--current"), !!ariaCurrent), "".concat(CSS_BLOCK, "__toolbar-overflow-button"), inToolbarOverflow)),
    innerTextClasses: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.innerTextClasses, "".concat(CSS_BLOCK, "__link-text")),
    onClick: (0, _chainFunction.default)(handleClick, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleNodeKeyDown, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onKeyDown),
    ref: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.ref) ? (0, _reactMergeRefs.default)([buttonProps.ref, internalButtonRef]) : internalButtonRef
  }), label, icon);
  var wrappedButton = tooltipMessage && !inToolbarOverflow && !isOpen ? ( /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, (0, _assign.default)({}, tooltipProps, {
    message: tooltipMessage
  }), buttonTarget)) : buttonTarget;
  return /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, itemProps, {
    role: "none",
    ref: ref,
    className: classnames(className, "".concat(CSS_BLOCK, "__wrapper")),
    onMouseEnter: (0, _chainFunction.default)(handleMouseEnter, itemProps === null || itemProps === void 0 ? void 0 : itemProps.onMouseEnter),
    onMouseLeave: (0, _chainFunction.default)(handleMouseLeave, itemProps === null || itemProps === void 0 ? void 0 : itemProps.onMouseLeave),
    onClick: onClick,
    onKeyDown: onKeyDown
  }), !children ? ( /*#__PURE__*/_react.default.createElement(_Link.Link, (0, _assign.default)({}, linkProps, {
    role: "menuitem",
    tabIndex: 0,
    matchButtonHeight: true,
    className: classnames(_constants.CSS_PREFIX, linkProps === null || linkProps === void 0 ? void 0 : linkProps.className, "".concat(CSS_BLOCK, "__link"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__link--md"), size === 'md'), "".concat(CSS_BLOCK, "__overlay-link"), typeof hideMainMenu === 'function'), "".concat(CSS_BLOCK, "__link--current"), !!ariaCurrent), "".concat(CSS_BLOCK, "__toolbar-overflow-link"), inToolbarOverflow)),
    innerTextClasses: classnames(linkProps === null || linkProps === void 0 ? void 0 : linkProps.innerTextClasses, "".concat(CSS_BLOCK, "__link-text")),
    href: href,
    onClick: (0, _chainFunction.default)(handleClick, linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick),
    onKeyDown: (0, _chainFunction.default)(handleLinkKeyDown, linkProps === null || linkProps === void 0 ? void 0 : linkProps.onKeyDown),
    "aria-current": ariaCurrent,
    "data-nui-widgets": "menuitem-leaf",
    ref: linkRef
  }), label)) : ( /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, (0, _assign.default)({
    offset: -5,
    popperPlacement: ['right-start', 'right', 'left-start', 'left', 'bottom-end', 'bottom', 'auto']
  }, overlayProps, {
    onShow: function onShow() {
      return setIsOpen(true);
    },
    onHide: function onHide() {
      setIsOpen(false);
    },
    ref: overlayRef,
    onClickOutside: function onClickOutside(event) {
      return (0, _navMenuUtils.handleOutsideClick)(event, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.onClickOutside, hideMainMenu, level);
    },
    popperProps: (0, _assign.default)((0, _assign.default)({
      role: 'presentation',
      'data-overflow-flyout': 'true',
      'data-nui-widgets': 'menu-overlay'
    }, overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps), {
      onKeyDown: (0, _chainFunction.default)(handleSubMenuKeyDown, handleTypeToFocus, (_b = overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.popperProps) === null || _b === void 0 ? void 0 : _b.onKeyDown)
    }),
    targetClassName: classnames("".concat(CSS_BLOCK, "__overlay")),
    targetComponent: wrappedButton,
    show: isOpen,
    focusManagerProps: {
      nextKeyCode: _keycode.default.codes.down,
      previousKeyCode: _keycode.default.codes.up,
      trapWithTabbing: true,
      onlyContainedEvents: true,
      useHomeAndEndKeys: true
    }
  }), /*#__PURE__*/_react.default.createElement("ul", (0, _assign.default)({}, submenuListProps, {
    role: "menu",
    className: classnames(CSS_BLOCK, submenuListProps === null || submenuListProps === void 0 ? void 0 : submenuListProps.className),
    ref: (submenuListProps === null || submenuListProps === void 0 ? void 0 : submenuListProps.ref) ? (0, _reactMergeRefs.default)([submenuListProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children)))));
});
NavMenuItem.displayName = 'NavMenuItem';
var _default = exports.default = NavMenuItem;